<template>
  <v-chip color="#CDE0FF" class="primary--text px-2" small>
    <v-icon small class="mr-2 material-icons-outlined">
      {{ icon }}
    </v-icon>
    <span class="font-weight-medium">{{ label }}</span>
  </v-chip>
</template>

<script>
import { ReviewStage } from '@/enums';
import { startCase } from 'lodash';

const STAGE_TO_ICON = {
  [ReviewStage.SCREENING]: 'thumb_up',
  [ReviewStage.FULL_TEXT_REVIEW]: 'find_in_page',
  [ReviewStage.DATA_EXTRACTION]: 'archive',
};

export default {
  name: 'ReviewStageChip',
  props: {
    stage: {
      type: String,
      required: true,
      validator: (value) =>
        Object.values(ReviewStage).includes(value),
    },
  },
  computed: {
    icon() {
      return STAGE_TO_ICON[this.stage];
    },
    label() {
      return startCase(this.stage.toLowerCase());
    },
  },
};
</script>
